import script from "./LogBook.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogBook.vue?vue&type=script&lang=ts&setup=true"

import "./LogBook.vue?vue&type=style&index=0&id=7d0e9267&lang=scss"

const __exports__ = script;

export default __exports__